import axios from "axios";

export interface SlcSignInRequestDto {
    email: string;
    password: string;
}

export interface SlcSignInUserDto {
    id: string;
    name: string;
    email: string;
    type: number;
}

export interface SlcSignInResponseDto {
    user: SlcSignInUserDto;
    accessToken: string;
    refreshToken?: string;
}

export interface SlcRefreshTokenRequestDto {
    refreshToken: string;
}

export interface SlcRefreshTokenResponseDto {
    accessToken?: string;
    refreshToken?: string;
    errorCode?: string;
}

export class SlcApplicationApis {
    private readonly server = axios.create({
        baseURL: import.meta.env.VITE_SLC_API_URL,
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store",
        },
    });

    async postSignIn(signInRequestDto: SlcSignInRequestDto) {
        const response = await this.server.post<SlcSignInResponseDto>(
            "/v3/sign-in",
            signInRequestDto,
        );

        return response.data;
    }

    async postRefreshToken(refreshToken: string) {
        const response = await this.server.post<SlcRefreshTokenResponseDto>("/v2/refresh-token", {
            refreshToken,
        } satisfies SlcRefreshTokenRequestDto);

        return response.data;
    }
}
